export const labelData: { [key: string]: string } = {
	// __simplici_kyc_aml_single_tile__: the canvas node is named for what the
	// step sells -- the same "KYC & AML" the Actions List card carries -- rather
	// than expanding the acronym. One name for one step, in both places.
	allId: 'KYC & AML',
	amlVerification: 'AML (Anti-Money Laundering)',
	accreditationVerify: 'Accreditation Verification',
	signAgreementVerification: 'Sign Agreement',
	fundInvestmentVerification: 'Fund Investment',
	formAction: 'Questionnaire',
	kybVerification: 'KYB',
	liveness: 'Liveness',
	// __simplici_kyc_node_rows__: named for the checks these are, and sold as, on
	// the public price list -- not for the documents they happen to accept.
	verify: 'KYC Global Document Validation',
	SSN: 'SSN(Social security number) verification',
	radio: 'Radio option group',
	kybForm: 'KYB Documents',
	accountForm: 'Individual or Business Questionnaire.',
	address: 'KYC Global Data Validation',
	// __simplici_kyc_ssn_verification__: a sub-check of the row above, not a
	// step of its own — Didit takes the SSN as an optional attribute on the
	// same database-validation call, which is why it costs nothing extra.
	ssnVerification: 'SSN or TIN Verification',
	// __simplici_criminal_background_check__: a check of its own, not a sub-check
	// — it costs $5 and runs on the identity the document check established.
	criminalBackgroundCheck: 'Criminal Background Check',
	proofVerification: 'Document Review',
	authentication: 'Authentication',
	successScreenCompletion: "Success Screen",
	basicInfo: 'Basic Info',
	secondContact: 'Second Contact'
};

export const DataTranferFile = {
	ApplicationType: 'application/complex-flow',
};

export const ActionList: Record<string, string> | any = {
	kyb: 'kybVerification',
	kyc: 'allId',
	form: 'formAction',
	signAgreement: 'signAgreementVerification',
	aml: 'amlVerification',
	amlVerification: 'aml',
	fund: 'fundInvestmentVerification',
	accreditation: 'accreditationVerify',
	kybVerification: 'kyb',
	allId: 'kyc',
	formAction: 'dynamicForm',
	accreditationVerify: 'accreditation',
	signAgreementVerification: 'signAgreement',
	fundInvestmentVerification: 'fundInvestment',
	kybForm: 'kybForm',
	accountForm: 'form',
	verify: 'idv',
	address: 'addressVerification',
	// __simplici_kyc_ssn_verification__: maps the row to its catalog metadata
	// entry so the tile reads THAT price (0) instead of falling back to the
	// KYC action's own $0.75 — this check rides on the data-validation call
	// that has already been paid for.
	ssnVerification: 'ssnVerification',
	SSN: 'ssn',
	proofReading: 'proofVerification',
	proofVerification: 'proofReading',
	authentication: 'authentication',
	successScreenCompletion: 'successScreen',
	successScreen: 'successScreenCompletion',
	// Basic Info (tier-0) maps to itself in both directions: action key === stepId === 'basicInfo'.
	basicInfo: 'basicInfo',
	// Second Contact (tier-0 OTP gate) maps to itself: action key === stepId === 'secondContact'.
	secondContact: 'secondContact',
};

// Arun kumar: kyb be added because by default we need to show green configed
export const ConfigurableSteps = [
	'kyc',
	'fundInvestment',
	'kyb',
	'signAgreement',
	'accreditation',
	'successScreenCompletion',
	'successScreen',
	'dynamicForm',
	'amlVerification',
	'aml',
	'authentication',
	'authentication',
];

// Arun kumar: kyb be added because by default we need to show green configed
export const StageConfigurableSteps = [
	'kyc',
	'fundInvestment',
	'aml',
	'amlVerification',
	'kyb',
	'successScreen',
	'successScreenCompletion',
	'signAgreement',
	'accreditation',
	'dynamicForm',
	'authentication',
	'authentication',
];

export const VerifyOptions = [
	{
		label: 'Approve',
		value: 'approve',
	},
	{
		label: 'Manual review',
		value: 'manualReview',
	},
	{
		label: 'Reject',
		value: 'reject',
	},
];

export const OperatorOptions = [
	{
		label: 'Equals to',
		value: '===',
	},
	{
		label: 'Greater than',
		value: '>',
	},
	{
		label: 'Greater than or equal to',
		value: '>=',
	},
	{
		label: 'Less than',
		value: '<',
	},
	{
		label: 'Less than or equal to',
		value: '<=',
	},
];

export const OperatorKey = {
	'===': 'Equals to',
	'>': 'Greater than',
	'>=': 'Greater than or equal to',
	'<': 'Less than',
	'<=': 'Less than or equal to',
};

export const KybSelectAnswer = [
	{
		label: 'Match',
		value: 'match',
	},
	{
		label: 'No Match',
		value: 'no-match',
	},
];

export const AmlSelectAnswer = [
	{
		label: 'True',
		value: 'true',
	},
	{
		label: 'False',
		value: 'false',
	},
];

export const AccreditationSelectAnswer = [
	{
		label: 'True',
		value: 'true',
	},
	{
		label: 'False',
		value: 'false',
	},
];

export const Ids: any = {
	liveness: 'liveliness',
	SSN: 'ssn',
	address: 'addressVerification',
};

export const QuestionnaireStep = {
	New: 'NEW',
	Old: 'OLD',
};

export const kybObjectStep = {
	_id: '653a299e5bbce8a6047f88e9',
	label: 'Questionnaire',
	description: 'General Questionare',
	key: 'dynamicForm',
	price: 0,
	metadata: [],
	stepKey: 'form',
	nodeId: 'node-f031199c-bff7-4e76-a878-cde657fa39fe',
};

export const RequiredValidationKeysForNodes: any = {
	aml: ['operand', 'param'],
	kyc: ['operand', 'param', 'operator'],
	accreditation: ['operand', 'param', 'operator'],
	kyb: ['operand', 'param'],
};

export const SuccessNode = {
	STEP_ID: 'successScreen',
	FORM_ID: 'form',
	FORM_INDIVIDUAL: '_multipleChoice_Individual',
	FORM_BUSINESS: '_multipleChoice_Business',
	ERROR_MESSAGE : 'The Success Screen cannot be incorporated within a conditional flow.'
};
